import { Fetcher } from 'swr'
import { client } from '~/api/client'
import { getCoordinateComments, Schemas } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'
import { Key } from './getCoordinateCommentsKey'

export const fetchGetCoordinateComments: Fetcher<
  Schemas.get_coordinate_comment_with_members_response,
  Key
> = async ([_, params]) => {
  const res = await getCoordinateComments(client, {
    parameter: params,
  })
  assertSuccess(res)
  return res.data
}
